import { PaperAirplaneIcon } from '@heroicons/react/24/outline';
import { DmBtnPrimary } from '../DmFormPrimitives';

interface ComposerSendButtonProps {
    isSending: boolean;
    disabled: boolean;
    onClick: () => void;
}

function ComposerSendButton({ isSending, disabled, onClick }: ComposerSendButtonProps) {
    return (
        <DmBtnPrimary size="sm" onClick={onClick} disabled={disabled}>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
                {isSending ? 'Sending…' : 'Send'}
                {!isSending && <PaperAirplaneIcon className="w-4 h-4" aria-hidden="true" />}
            </span>
        </DmBtnPrimary>
    );
}

export { ComposerSendButton };
